import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as wizeMobileApi from '@wize-mobile-api';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { selectUserRole } from '@qvs/core/user';
import { Currency, UserRoleEnum } from '@qvs/core';
import { CurrenciesMapper } from './currencies.mapper';

@Injectable({
  providedIn: 'root'
})
export class CurrenciesService {
  constructor(
    private readonly store: Store,
    private readonly basicDataApi: wizeMobileApi.BasicDataMobileService
  ) {}

  loadCurrencies(): Observable<Currency[]> {
    return this.store.select(selectUserRole).pipe(
      switchMap((userRole) =>
        userRole === UserRoleEnum.CLIENT
          ? this.basicDataApi.listCurrencies('CURRENCY').pipe(
              map((currencies) => CurrenciesMapper.fromWizeListCurrencies(currencies)),
              catchError((e) => throwError(() => e))
            )
          : of([])
      )
    );
  }
}
